import MagnifyIcon from "mdi-react/MagnifyIcon";
import { useState } from "react";
import { Table, Form } from "react-bootstrap";
import { useQuery } from "react-query";
import { useAuth } from "../../hooks/useAuth";
import useDebounce from "../../utils/hooks";
import queryString from "query-string";
import ReactPaginate from "react-paginate";
import { paginationOptions } from "../../utils/helpers";
import "./../../assets/scss/scoped/items-table.scoped.scss";

export default function TripSelector({
  handleSelectedTrip,
  selectedTrip = {},
  status,
  vehicle_id,
  driver_id,
  route_id,
}) {
  const { backendUrl } = useAuth();
  const [queryParams, setQueryParams] = useState({
    page: 1,
    limit: 20,
    q: "",
    ...(status ? { status } : {}),
    ...(vehicle_id ? { vehicle_id } : {}),
    ...(driver_id ? { driver_id } : {}),
    ...(route_id ? { route_id } : {}),
  });

  const debouncedqueryParams = useDebounce(queryParams, 500);

  const getTrips = async debouncedqueryParams => {
    let response = await fetch(
      `${backendUrl}/api/fleet/trips?${queryString.stringify(
        debouncedqueryParams
      )}`,
      {
        method: "GET",
        headers: {
          Accept: "Application/json",
          "Content-Type": "Application/json",
        },
        credentials: "include",
      }
    );

    if (!response.ok) {
      response = await response.json();
      throw new Error(response.message);
    }

    const { data } = await response.json();
    return data;
  };

  const { data = { trips: [], count: 0 } } = useQuery(
    ["TRIP_SELECTOR", debouncedqueryParams],
    () => getTrips(debouncedqueryParams),
    {
      enabled: true,
      keepPreviousData: true,
    }
  );

  return (
    <div className="items-table-area rounded">
      <div className="search-area m-3">
        <MagnifyIcon />
        <Form.Control
          className="search-input"
          value={queryParams.q}
          onChange={e =>
            setQueryParams({
              ...queryParams,
              page: 1,
              q: e.target.value,
            })
          }
          placeholder="Search trip number..."
          autoFocus
          autoComplete="off"
        />
      </div>

      <div className="content">
        <Table borderless hover striped className="product-table">
          <thead className="sticky text-nowrap">
            <tr>
              <th scope="col">Trip Number</th>
              <th scope="col">Vehicle</th>
              <th scope="col">Status</th>
            </tr>
          </thead>
          <tbody>
            {data.trips && data.trips.length > 0 ? (
              data.trips.map((el, index) => (
                <tr
                  className={`p-cursor ${
                    selectedTrip?.trip_id === el.trip_id ? "active-row" : ""
                  }`}
                  key={el.trip_id || index}
                  onClick={() => handleSelectedTrip(el)}
                >
                  <td>{el.tripNumber}</td>
                  <td>{el.vehicle?.licensePlate || "..."}</td>
                  <td>{el.status}</td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan={3} className="text-center py-3">
                  No trips found
                </td>
              </tr>
            )}
          </tbody>
        </Table>
      </div>

      <div className="d-flex justify-content-between px-3 my-3 align-items-center pagination">
        <p className="m-0">
          Showing{" "}
          {data.count === 0 ? 0 : (queryParams.page - 1) * queryParams.limit + 1}{" "}
          to{" "}
          {Math.min(queryParams.page * queryParams.limit, data.count)} of{" "}
          {data.count} entries
        </p>

        <ReactPaginate
          {...paginationOptions}
          pageCount={Math.ceil(data.count / queryParams.limit)}
          marginPagesDisplayed={2}
          pageRangeDisplayed={0}
          onPageChange={({ selected }) =>
            setQueryParams({ ...queryParams, page: selected + 1 })
          }
          forcePage={queryParams.page - 1}
        />
      </div>
    </div>
  );
}
